<template>
 <div></div>
</template>

<script>
import {storeFcmToken} from '../boot/axios';

export default {
  name: 'PushHandler',
  async mounted() {
    try {
      FCM.requestPushPermission();
    } catch(e) {

    }

    try {
      cordova.plugins.notification.badge.requestPermission()
    } catch (e) {

    }

    try {
      let that = this

      cordova.plugins.notification.local.on("click", () => {
        that.$router.push('/notifications')
      })
    } catch (e) {

    }


    try {

      if(this.$store.state.mainStore.user.id){
        // eslint-disable-next-line no-undef
        let token = await FCM.getToken()
        storeFcmToken(token)
      }

      // eslint-disable-next-line no-undef
      FCM.onTokenRefresh(function(token){
        storeFcmToken(token)
      });

      let notified = []

      // eslint-disable-next-line no-undef
      FCM.onNotification((data) => {
        if(data.wasTapped){
          let link = data.link || '/notifications'

          return this.$router.push(link)
        }

        if (data.meta && data.meta.plugin === 'cordova-plugin-local-notification' && !data.wasTapped) {
          return;
        }

        if(data['gcm.message_id']){
          if(notified.indexOf(data['gcm.message_id']) > -1){
            return
          }

          notified.push(data['gcm.message_id'])

          this.$store.commit('mainStore/notifications', notified.length)
          try {
            cordova.plugins.notification.badge.set(notified.length);
          } catch (e) {
            let a = 1
          }
        }

        let text = data.body

        cordova.plugins.notification.local.schedule({
          title: data.title,
          text: text,
          foreground: this.$q.platform.is.ios
        });

        if(this.$q.platform.is.android){
          this.$q.notify({
            color: 'white',
            title: data.title,
            message: `<strong>${data.title}</strong><br/>${text}`,
            html: true,
            multiLine: true,
            textColor: 'dark',
            actions: [
              {
                icon: '', label: 'Open', color: 'dark', handler: () => {
                  this.$router.push('/notifications')
                }
              },
              { icon: 'ion-ios-close', label: 'Close', color: 'dark' },

            ]
          })
        }
      });
    } catch (e) {

    }
  }
}
</script>

<style scoped>

</style>
